import { Badge, Heading, Text, Box, Stack, Button, Flex, Image } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { logoFigmaVersion } from '../../assets/new-images/logos';

export default function CertificationResume({
 id,
 name,
 color,
 sealUrl,
 isDefaultSeal,
 children
}) {
 return (
  <Flex h='203px' bg={color} pos='relative' borderRadius='12px' overflow='hidden'>
   <Flex w='65%' h='full' p='6' borderTopLeftRadius='12px' borderBottomLeftRadius='12px'>
    <Stack color='#FFFFFF' w='full'>
     <Box>
      <Box width='20px' height='5px' bgColor='#8AD657' borderRadius='6px' mb='8px' />
      <Heading
       as='h3'
       fontSize={{ lg: '16px', '2xl': '18px' }}
       lineHeight='28px'
       fontWeight={700}
       maxW='80%'
      >
       {name}
      </Heading>
     </Box>
    
     <Button
      as={Link}
      to={`edit/${id}`}
      p={0}
      variant='link'
      color='white'
      pos='absolute'
      left='6'
      bottom='75px'
      justifyContent='start'
      _active={{
        color: 'white'
      }}
     >
      <Text as='span' fontWeight={600} textDecor='underline'>
       Acessar questionário
      </Text>
     </Button>
     {children}
    </Stack>
   </Flex>

   <Flex
    w='35%'
    h='full'
    align='center'
    pos='relative'
    borderTopRightRadius='12px'
    borderBottomRightRadius='12px'
   >
    <Flex w='380px' h='380px' bg='white' borderRadius='full' pos='absolute' />
    <Image
     src={sealUrl || logoFigmaVersion}
     alt={sealUrl ? 'Selo da certificação' : 'Logo'}
     mx='auto'
     maxW='130px'
     maxH='120px'
     objectFit='contain'
     pos='relative'
    />
    {sealUrl && isDefaultSeal && (
     <Badge
      pos='absolute'
      bottom='12px'
      right='12px'
      bg='#5C6066'
      color='white'
      fontSize='10px'
      borderRadius='4px'
      px='6px'
     >
      Selo padrão
     </Badge>
    )}
   </Flex>
  </Flex>
 );
}

